import * as providers from "../api/providers";

export default {
  state: {
    providers: [],
    provider: {}
  },
  mutations: {
    getProviders(state, providers) {
      state.providers = providers;
    },
    getProvider(state, provider) {
      state.provider = provider;
    }
  },
  actions: {
    async getProviders({ commit }) {
      const data = await providers.getProviders();
      commit("getProviders", data);
    },
    async getProvider({ commit }, id) {
      const data = await providers.getProvider(id);
      commit("getProvider", data);
    }
  }
};
